import { buildSelector } from '@/shared/lib/store';

export const [useSessionIsAuthorized] = buildSelector(
    (state) => state.session.isAuthorized,
);
